var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFollowerVine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m21.27,548.61c-25.35,-31.69 4.23,-104.93 22.54,-127.46c18.31,-22.54 69.01,-34.51 96.48,-7.04c27.46,27.46 11.27,57.04 66.2,68.31c54.93,11.27 77.46,-51.41 28.87,-90.14c-48.59,-38.73 -66.2,-19.01 -100,-25.35c-33.8,-6.34 -69.01,-38.73 -73.38,-89.45c-4.37,-50.72 48.73,-66.89 85.35,-59.85c36.62,7.04 52.11,42.25 58.45,53.52c6.34,11.27 22.54,52.11 38.59,50.69c16.06,-1.42 38.87,-40.83 36.76,-78.86c-2.11,-38.03 -10.56,-97.18 -37.32,-116.9c-26.76,-19.72 -81.69,-34.51 -111.27,-12.68c-29.58,21.83 -19.01,56.34 -54.93,69.01c-35.92,12.68 -76.06,-11.27 -70.42,-47.89c5.63,-36.62 26.76,-52.11 45.77,-66.9c19.01,-14.79 78.17,-57.04 129.44,-59.17c51.27,-2.13 87.46,2.13 104.93,15.49c17.46,13.37 24.08,41.56 26.06,64.79c1.97,23.23 -1.97,126.77 -2.11,267.61c-0.14,140.83 6.48,170.44 -9.86,188.03c-16.34,17.59 -85.77,-7.03 -138.59,-3.51c-52.82,3.52 -116.2,39.44 -141.55,7.75z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_19",
    stroke: "#f90000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFollowerVine3);
export default __webpack_public_path__ + "static/media/mobileFollowerVine3.ec3c095b780a5d0293b3ec719c50c7e7.svg";
export { ForwardRef as ReactComponent };